var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExecutionCheckIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4 0H1.6C0.72 0 0 0.72 0 1.6V12.8C0 13.68 0.72 14.4 1.6 14.4H14.4C15.28 14.4 16 13.68 16 12.8V1.6C16 0.72 15.28 0 14.4 0ZM5.6 11.2H3.2C2.76 11.2 2.4 10.84 2.4 10.4C2.4 9.96 2.76 9.6 3.2 9.6H5.6C6.04 9.6 6.4 9.96 6.4 10.4C6.4 10.84 6.04 11.2 5.6 11.2ZM5.6 8H3.2C2.76 8 2.4 7.64 2.4 7.2C2.4 6.76 2.76 6.4 3.2 6.4H5.6C6.04 6.4 6.4 6.76 6.4 7.2C6.4 7.64 6.04 8 5.6 8ZM5.6 4.8H3.2C2.76 4.8 2.4 4.44 2.4 4C2.4 3.56 2.76 3.2 3.2 3.2H5.6C6.04 3.2 6.4 3.56 6.4 4C6.4 4.44 6.04 4.8 5.6 4.8ZM13.36 6.496L10.824 9.032C10.512 9.344 10 9.344 9.688 9.032L8.56 7.896C8.248 7.584 8.248 7.08 8.56 6.768C8.872 6.456 9.376 6.456 9.688 6.768L10.256 7.336L12.232 5.36C12.544 5.048 13.048 5.048 13.36 5.36L13.368 5.368C13.672 5.68 13.672 6.192 13.36 6.496Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecutionCheckIcon);
export default __webpack_public_path__ + "static/media/executionCheckIcon.9838baa4.svg";
export { ForwardRef as ReactComponent };